import { render } from "./Laporan.vue?vue&type=template&id=32cebbd4&scoped=true"
import script from "./Laporan.vue?vue&type=script&lang=js"
export * from "./Laporan.vue?vue&type=script&lang=js"

import "./Laporan.vue?vue&type=style&index=0&id=32cebbd4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cebbd4"]])

export default __exports__